import React from 'react';
import { Spinner } from 'react-bootstrap';

/** Shown while a page's code downloads. */
export default function PageLoading() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
            <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading…</span>
            </Spinner>
        </div>
    );
}
